import React from 'react';

const PDHeader2 = (props) => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-6">
                    <h3 id="productName">{props.item.ProductName}</h3>
                    {props.item.ProductTag1 !== "" ? < h4 id="productTag1">{props.item.ProductTag1}</h4> : null}
                    <div id="highlightdetails">
                        test
                    </div>
                </div>
                <div className="col-6">
                    <img height="300px" src={props.item.PictureLink}></img>
                </div>
            </div>
        </div>
    )
}

export default PDHeader2;